import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import i18next from "i18next";
import "./i18n";
import { I18nextProvider } from "react-i18next";

// Set favicon and manifest based on destination
const setFaviconAndManifest = () => {
  const isUSA = process.env.REACT_APP_DESTINATION === "USA";
  const faviconPath = isUSA ? "/favicon_usa.png" : "/favicon.ico";
  const manifestPath = isUSA ? "/manifest_usa.json" : "/manifest.json";

  // Update all favicon link elements
  const faviconLinks = document.querySelectorAll("link[rel*='icon']");
  faviconLinks.forEach((link) => {
    (link as HTMLLinkElement).href = faviconPath;
  });

  // If no favicon link exists, create one
  if (faviconLinks.length === 0) {
    const link = document.createElement("link");
    link.rel = "icon";
    link.href = faviconPath;
    document.head.appendChild(link);
  }

  // Update manifest link
  const manifestLink = document.querySelector("link[rel='manifest']") as HTMLLinkElement;
  if (manifestLink) {
    manifestLink.href = manifestPath;
  } else {
    // Create manifest link if it doesn't exist
    const link = document.createElement("link");
    link.rel = "manifest";
    link.href = manifestPath;
    document.head.appendChild(link);
  }
};

// Set favicon and manifest immediately
setFaviconAndManifest();

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);
